import React, { useState, useEffect } from "react";
import api from "../Services/api";
import icoDownload from '../../assets/img/ico-download.svg';

const RelatoriosAnuais = (props: any) => {

  const [relatorios, setRelatorios] = useState<any[]>([]);

  function newObject(data: any) {
    var relatorios: any[] = [];
    var resumos: any[] = [];

    var obj: any[] = [];;
    data.map((item: any) => {
      if (item.Tipo === "Relatório") {
        relatorios.push(item);
      } else if (item.Tipo === "Resumo") {
        resumos.push(item);
      }
      return true;
    });
    for (var i = 0; i < relatorios.length; i++) {
      var payload = { Title: "", URL: "", URLResume: "", UrlImage: "" };
      let relatorio = relatorios[i];
      let resumo = resumos.find(element => element.Title.includes(relatorio.Title));
      payload.Title = relatorio.Title;
      payload.URL = decodeURIComponent(relatorio.URL);
      payload.URLResume = resumo ? relatorio.URL : "";
      payload.UrlImage = relatorio.UrlImage;
      obj.push(payload);
    };
    setRelatorios(obj);
  }

  useEffect(() => {
    api
      .get("/ObterRelatorioAnualAtividades")
      .then((response) => {
        newObject(response.data.results);
      })
      .catch((err) => {
        throw new Error(err);
      });
  }, []);
  return (
    <div className="col-lg-10">
      <div className="row">

        {relatorios?.map((item: any, index: any) => (
          <div key={index} className="col-md-6">
            <div className="box-pdf mt-4 mb-10">
              <div className="container_1"> 
                <img src={item.UrlImage ? item.UrlImage : props.fileImg}  alt="Organograma" className="mb-5 image"/>
              </div>
              <div className="my-3"> 
                <span> <strong> {item.Title} </strong> </span> <br />
              </div>
              <a href={item.URL} target="_blank" className="d-flex mt-3" rel="noreferrer">

                <a href={item.URL} target="_blank" className="btn btn-primary rounded p-0 btn-100" rel="noreferrer">
                  <img style={{ maxWidth: "80%" }} src={icoDownload} alt="Ícone" />
                </a>
                <span className="text ml-3">
                  Completo
                </span>
              </a>
              {item.URLResume !== "" && <a href={item.URLResume} target="_blank" className="d-flex mt-3" rel="noreferrer">

                <a href={item.URLResume} target="_blank" className="btn btn-primary rounded p-0 btn-100" rel="noreferrer">
                  <img style={{ maxWidth: "80%" }} src={icoDownload} alt="Ícone" />
                </a>
                <span className="text ml-3">
                  Versão resumida
                </span>
              </a>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default RelatoriosAnuais;

